import startCase from 'lodash/startCase';

import { TaxDocument, DocumentType, TaxAuthority } from '@neo.tax/shared';

export const toTaxDocumentName = (taxDocument: TaxDocument): string => {
  switch (taxDocument.documentType) {
    case DocumentType.RdCreditAndCapitalizationWithInstructions:
      return 'Form 6765';
    case DocumentType.RdCredit:
    case DocumentType.RdCreditWithInstructions:
      if (taxDocument.taxAuthority === TaxAuthority.Federal) {
        return 'R&D Credit';
      } else {
        // giving a meaningful name for the state credit is being addressed in a hotfix
        // as an fyi, what we get for DISTRINCT_OF_COLUMBIA is "District Of Columbia"
        return `${startCase(taxDocument.taxAuthority.toLowerCase())} R&D Credit`;
      }
    case DocumentType.WriteUp:
      return 'Write Up';
    case DocumentType.GaapCapExcelReport:
      return 'ASC Excel Report';
  }
  throw new Error(`${taxDocument.taxAuthority} ${taxDocument.documentType} should not be used as a tax document`);
};

const taxAuthorityName: Record<TaxAuthority, string> = {
  [TaxAuthority.Alabama]: 'Alabama',
  [TaxAuthority.Alaska]: 'Alaska',
  [TaxAuthority.AmericanSamoa]: 'American Samoa',
  [TaxAuthority.Arizona]: 'Arizona',
  [TaxAuthority.Arkansas]: 'Arkansas',
  [TaxAuthority.California]: 'California',
  [TaxAuthority.Colorado]: 'Colorado',
  [TaxAuthority.Connecticut]: 'Connecticut',
  [TaxAuthority.Delaware]: 'Delaware',
  [TaxAuthority.DistrictOfColumbia]: 'District of Columbia',
  [TaxAuthority.Federal]: 'Federal',
  [TaxAuthority.FederatedStatesOfMicronesia]: 'Federated States of Micronesia',
  [TaxAuthority.Florida]: 'Florida',
  [TaxAuthority.Georgia]: 'Georgia',
  [TaxAuthority.Guam]: 'Guam',
  [TaxAuthority.Hawaii]: 'Hawaii',
  [TaxAuthority.Idaho]: 'Idaho',
  [TaxAuthority.Illinois]: 'Illinois',
  [TaxAuthority.Indiana]: 'Indiana',
  [TaxAuthority.Iowa]: 'Iowa',
  [TaxAuthority.Kansas]: 'Kansas',
  [TaxAuthority.Kentucky]: 'Kentucky',
  [TaxAuthority.Louisiana]: 'Louisiana',
  [TaxAuthority.Maine]: 'Maine',
  [TaxAuthority.MarshallIslands]: 'Marshall Islands',
  [TaxAuthority.Maryland]: 'Maryland',
  [TaxAuthority.Massachusetts]: 'Massachusetts',
  [TaxAuthority.Michigan]: 'Michigan',
  [TaxAuthority.Minnesota]: 'Minnesota',
  [TaxAuthority.Mississippi]: 'Mississippi',
  [TaxAuthority.Missouri]: 'Missouri',
  [TaxAuthority.Montana]: 'Montana',
  [TaxAuthority.Nebraska]: 'Nebraska',
  [TaxAuthority.Nevada]: 'Nevada',
  [TaxAuthority.NewHampshire]: 'New Hampshire',
  [TaxAuthority.NewJersey]: 'New Jersey',
  [TaxAuthority.NewMexico]: 'New Mexico',
  [TaxAuthority.NewYork]: 'New York',
  [TaxAuthority.NorthernMarianaIslands]: 'Northern Mariana Islands',
  [TaxAuthority.NorthCarolina]: 'North Carolina',
  [TaxAuthority.NorthDakota]: 'North Dakota',
  [TaxAuthority.Ohio]: 'Ohio',
  [TaxAuthority.Oklahoma]: 'Oklahoma',
  [TaxAuthority.Oregon]: 'Oregon',
  [TaxAuthority.Palau]: 'Palau',
  [TaxAuthority.Pennsylvania]: 'Pennsylvania',
  [TaxAuthority.PuertoRico]: 'Puerto Rico',
  [TaxAuthority.RhodeIsland]: 'Rhode Island',
  [TaxAuthority.SouthCarolina]: 'South Carolina',
  [TaxAuthority.SouthDakota]: 'South Dakota',
  [TaxAuthority.Tennessee]: 'Tennessee',
  [TaxAuthority.Texas]: 'Texas',
  [TaxAuthority.Utah]: 'Utah',
  [TaxAuthority.Vermont]: 'Vermont',
  [TaxAuthority.Virginia]: 'Virginia',
  [TaxAuthority.VirginIslands]: 'Virgin Islands',
  [TaxAuthority.Washington]: 'Washington',
  [TaxAuthority.WestVirginia]: 'West Virginia',
  [TaxAuthority.Wisconsin]: 'Wisconsin',
  [TaxAuthority.Wyoming]: 'Wyoming',
};

export const toTaxAuthorityName = (taxAuthority: TaxAuthority): string => taxAuthorityName[taxAuthority];
